import { render, staticRenderFns } from "./BuscarItinerariosPageTab.vue?vue&type=template&id=54ad24cc"
import script from "./BuscarItinerariosPageTab.vue?vue&type=script&lang=js"
export * from "./BuscarItinerariosPageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports